(function() {
  'use strict';

  /* ========================================
     Wishlist (localStorage)
     ======================================== */
  var WISHLIST_KEY = 'gjones-wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) { list.push(handle); }
    else { list.splice(idx, 1); }
    saveWishlist(list);
    return idx === -1;
  }

  /* ========================================
     Add to Cart
     ======================================== */
  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }], sections: sections })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      // Shopify error responses have a `status` field (e.g. 422)
      if (data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        cartDrawer.renderContents(data);
      }
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gjones-quick-add', cartData: data });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return data;
    });
  }

  /* ========================================
     Inline Size Panel (overlay card layout)
     ======================================== */
  function openInlinePanel(card) {
    // Close any other open panels first
    document.querySelectorAll('.gjones-card__inline-sizes.is-open').forEach(function(p) {
      var other = p.closest('.gjones-card');
      if (other && other !== card) closeInlinePanel(other);
    });
    var panel = card.querySelector('[data-inline-sizes]');
    if (!panel) return;
    panel.classList.remove('is-closing');
    panel.classList.add('is-open');
  }

  function closeInlinePanel(card) {
    var panel = card.querySelector('[data-inline-sizes]');
    if (!panel || (!panel.classList.contains('is-open') && !panel.classList.contains('is-closing'))) return;
    panel.classList.add('is-closing');
    panel.classList.remove('is-open');
    function onEnd() {
      panel.removeEventListener('animationend', onEnd);
      panel.classList.remove('is-closing');
    }
    panel.addEventListener('animationend', onEnd);
  }

  function initInlinePanel(section) {
    section.addEventListener('click', function(e) {
      // Quick-add trigger on overlay cards → open inline panel
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (trigger) {
        var card = trigger.closest('.gjones-card');
        if (card && card.querySelector('[data-inline-sizes]')) {
          e.preventDefault();
          openInlinePanel(card);
        }
        return;
      }

      // Close button
      var closeBtn = e.target.closest('[data-inline-close]');
      if (closeBtn) {
        var card = closeBtn.closest('.gjones-card');
        if (card) closeInlinePanel(card);
        return;
      }

      // Color swatch
      var colorBtn = e.target.closest('[data-inline-color]');
      if (colorBtn) {
        var card = colorBtn.closest('.gjones-card');
        if (!card) return;
        var panel = card.querySelector('[data-inline-sizes]');
        if (!panel) return;
        var color = colorBtn.getAttribute('data-inline-color');
        var colorImg = colorBtn.getAttribute('data-color-image');

        panel.querySelectorAll('[data-inline-color]').forEach(function(b) { b.classList.remove('is-active'); });
        colorBtn.classList.add('is-active');

        var labelSpan = panel.querySelector('[data-inline-color-label] span');
        if (labelSpan) labelSpan.textContent = color;

        if (colorImg) {
          var img = card.querySelector('.gjones-card__img--primary');
          if (img) { img.src = colorImg; img.srcset = ''; }
        }

        panel.querySelectorAll('[data-inline-size]').forEach(function(btn) {
          var btnColor = btn.getAttribute('data-color');
          btn.classList.toggle('is-hidden', !!btnColor && btnColor !== color);
          btn.classList.remove('is-active');
        });

        var atcBtn = panel.querySelector('[data-inline-atc]');
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'SELECT SIZE';
          atcBtn.removeAttribute('data-variant-id');
        }
        return;
      }

      // Size selection
      var sizeBtn = e.target.closest('[data-inline-size]');
      if (sizeBtn && !sizeBtn.disabled) {
        var card = sizeBtn.closest('.gjones-card');
        if (!card) return;
        var panel = card.querySelector('[data-inline-sizes]');
        if (!panel) return;
        panel.querySelectorAll('[data-inline-size]').forEach(function(b) { b.classList.remove('is-active'); });
        sizeBtn.classList.add('is-active');
        var vid = sizeBtn.getAttribute('data-variant-id');
        var atcBtn = panel.querySelector('[data-inline-atc]');
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'ADD TO BAG';
          atcBtn.setAttribute('data-variant-id', vid);
        }
        return;
      }

      // ATC button
      var atcBtn = e.target.closest('[data-inline-atc]');
      if (atcBtn && !atcBtn.disabled) {
        var vid = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        var origText = atcBtn.textContent;
        atcBtn.innerHTML = '<span class="gjones-spinner"></span>';
        atcBtn.disabled = true;
        addToCart(vid).then(function() {
          atcBtn.innerHTML = SUCCESS_ICON;
          var card = atcBtn.closest('.gjones-card');
          setTimeout(function() {
            if (card) closeInlinePanel(card);
            atcBtn.textContent = origText;
            atcBtn.disabled = false;
          }, 900);
        }).catch(function(err) {
          atcBtn.textContent = err.message || origText;
          atcBtn.disabled = false;
        });
        return;
      }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-inline-sizes]') || e.target.closest('[data-quick-add-trigger]')) return;
      section.querySelectorAll('.gjones-card__inline-sizes.is-open').forEach(function(panel) {
        var card = panel.closest('.gjones-card');
        if (card) closeInlinePanel(card);
      });
    });
  }

  /* ========================================
     Section Init
     ======================================== */
  function initSection(section) {
    var mobileMode = section.getAttribute('data-mobile-quick-add') || 'sheet';
    initTabs(section);
    initSliders(section);
    initQuickAddDesktop(section, mobileMode);
    initInlinePanel(section);
    if (mobileMode === 'sheet') initQuickAddMobile(section);
    initWishlistButtons(section);
    initSwatches(section);
  }

  /* ========================================
     Tabs
     ======================================== */
  function initTabs(section) {
    var tabs = section.querySelectorAll('[data-tab-index]');
    var panels = section.querySelectorAll('[data-tab-panel]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var index = tab.getAttribute('data-tab-index');

        tabs.forEach(function(t) {
          t.classList.remove('gjones-collection-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('gjones-collection-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function(p) {
          p.classList.remove('gjones-collection-tabs__panel--active');
        });

        var activePanel = section.querySelector('[data-tab-panel="' + index + '"]');
        if (activePanel) {
          activePanel.classList.add('gjones-collection-tabs__panel--active');
          var track = activePanel.querySelector('[data-slider-track]');
          if (track) track.scrollLeft = 0;
          updateArrows(activePanel.querySelector('[data-slider]'));
        }
      });
    });
  }

  /* ========================================
     Slider (CSS scroll-snap + arrows)
     ======================================== */
  function initSliders(section) {
    section.querySelectorAll('[data-slider]').forEach(function(slider) {
      var track = slider.querySelector('[data-slider-track]');
      var prevBtn = slider.querySelector('[data-slider-prev]');
      var nextBtn = slider.querySelector('[data-slider-next]');
      if (!track) return;

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -getScrollAmount(track), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: getScrollAmount(track), behavior: 'smooth' });
        });
      }

      var scrollTimer;
      track.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() { updateArrows(slider); }, 50);
      });

      updateArrows(slider);

      var resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() { updateArrows(slider); }, 100);
      });
    });
  }

  function getScrollAmount(track) {
    var firstCard = track.firstElementChild;
    if (!firstCard) return track.offsetWidth;
    var gap = parseInt(getComputedStyle(track).gap) || 0;
    return firstCard.offsetWidth + gap;
  }

  function updateArrows(slider) {
    if (!slider) return;
    var track = slider.querySelector('[data-slider-track]');
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');
    if (!track) return;

    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 1;

    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
  }

  /* ========================================
     Quick Add — Desktop Modal
     ======================================== */
  function initQuickAddDesktop(section, mobileMode) {
    var modal = section.querySelector('[data-quick-add-modal]');

    // Event delegation — works for both static and AJAX-loaded cards
    section.addEventListener('click', function(e) {
      // Direct add (single variant, no modal)
      var directBtn = e.target.closest('.gjones-card__quick-add-trigger--direct[data-quick-add-direct]');
      if (directBtn) {
        e.preventDefault();
        var vid = parseInt(directBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        var label = directBtn.innerHTML;
        directBtn.innerHTML = '<span class="gjones-spinner"></span>';
        addToCart(vid).then(function() {
          showSuccess(directBtn, label);
        }).catch(function() { directBtn.innerHTML = label; });
        return;
      }

      // Modal trigger (standard layout — overlay cards handled by initInlinePanel)
      var trigger = e.target.closest('[data-quick-add-trigger]');
      if (!trigger && mobileMode === 'modal') trigger = e.target.closest('[data-quick-add-mobile]');
      if (trigger) {
        e.preventDefault();
        var card = trigger.closest('.gjones-card');
        if (!card) return;
        // Layout 3 grids handle QA via size bar + gjones-grid3-sheet (gjones-product-grid-3.js)
        if (card.closest('.gjones-product-grid--layout-3')) return;
        // Overlay cards use inline panel — skip modal
        if (card.querySelector('[data-inline-sizes]')) return;
        if (!modal) return;
        var dataEl = card.querySelector('[data-product-data]');
        if (!dataEl) return;
        try {
          var productData = JSON.parse(dataEl.textContent);
          openModal(modal, productData, card);
        } catch (err) {}
      }
    });

    // Modal close buttons, outside click & keyboard (static HTML — bind once)
    if (modal) {
      modal.querySelectorAll('[data-modal-close]').forEach(function(el) {
        el.addEventListener('click', function() { closeModal(modal); });
      });
      modal.addEventListener('click', function(e) {
        if (e.target === modal || e.target === modal.querySelector('.gjones-modal__backdrop')) {
          closeModal(modal);
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal(modal);
        }
      });
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  var SUCCESS_ICON = '<span class="gjones-success-icon"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle class="gjones-success-icon__circle" cx="9" cy="9" r="8"/><polyline class="gjones-success-icon__tick" points="5.5,9 7.5,11.5 12.5,6.5"/></svg></span>';

  function showSuccess(btn, restore, delay) {
    btn.innerHTML = SUCCESS_ICON;
    setTimeout(function() { btn.innerHTML = restore; }, delay || 1400);
  }

  function openModal(modal, productData, card) {
    var imgEl      = modal.querySelector('[data-modal-img]');
    var titleEl    = modal.querySelector('[data-modal-title]');
    var priceEl    = modal.querySelector('[data-modal-price]');
    var bodyEl     = modal.querySelector('[data-modal-body]');
    var viewLink   = modal.querySelector('[data-modal-product-link]');
    var prevBtn    = modal.querySelector('[data-modal-img-prev]');
    var nextBtn    = modal.querySelector('[data-modal-img-next]');
    var sizesWrap  = modal.querySelector('[data-modal-sizes]');
    var sizeOpts   = modal.querySelector('[data-modal-size-options]');
    var sizeValEl  = modal.querySelector('[data-modal-size-value]');
    var atcBtn     = modal.querySelector('[data-modal-add-to-cart]');
    var qtyValEl   = modal.querySelector('[data-modal-qty-value]');
    var minusBtn   = modal.querySelector('[data-modal-qty-minus]');
    var plusBtn    = modal.querySelector('[data-modal-qty-plus]');

    // -- Title & link --
    var cardTitle = card.querySelector('.gjones-card__title');
    if (titleEl) titleEl.textContent = cardTitle ? cardTitle.textContent.trim() : '';
    if (viewLink) viewLink.href = productData.url || '#';

    // -- Collect all images for carousel --
    var images = [];
    var primaryImg = card.querySelector('.gjones-card__img--primary');
    if (primaryImg && primaryImg.src) images.push(primaryImg.src);
    var hoverImg = card.querySelector('.gjones-card__img--hover');
    if (hoverImg && hoverImg.src && hoverImg.src !== images[0]) images.push(hoverImg.src);
    productData.variants.forEach(function(v) {
      if (v.image && images.indexOf(v.image) === -1) images.push(v.image);
    });
    if (images.length === 0) images.push('');

    // -- Carousel --
    var currentImgIdx = 0;
    var IMG_FADE_MS = 200;
    function showImage(idx) {
      currentImgIdx = Math.max(0, Math.min(idx, images.length - 1));
      if (prevBtn) prevBtn.hidden = currentImgIdx === 0;
      if (nextBtn) nextBtn.hidden = currentImgIdx >= images.length - 1;
      if (!imgEl) return;

      var newSrc = images[currentImgIdx];
      var alt = titleEl ? titleEl.textContent : '';
      var imageReady = false;
      var fadeComplete = false;

      function swapImage() {
        if (!imageReady || !fadeComplete) return;
        imgEl.src = newSrc;
        imgEl.alt = alt;
        // Two rAFs ensure the new src is painted before the fade-in starts
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            imgEl.style.opacity = '1';
          });
        });
      }

      imgEl.style.opacity = '0';
      setTimeout(function() { fadeComplete = true; swapImage(); }, IMG_FADE_MS);

      var tmp = new Image();
      tmp.src = newSrc;
      if (tmp.complete) {
        imageReady = true;
      } else {
        tmp.onload = tmp.onerror = function() { imageReady = true; swapImage(); };
      }
    }
    if (prevBtn) prevBtn.onclick = function() { showImage(currentImgIdx - 1); };
    if (nextBtn) nextBtn.onclick = function() { showImage(currentImgIdx + 1); };
    showImage(0);

    // -- Price --
    if (priceEl) {
      var priceVariant = productData.variants.filter(function(v) { return v.available; })[0] || productData.variants[0];
      if (priceVariant) {
        if (priceVariant.compareAtPrice && priceVariant.compareAtPrice > priceVariant.price) {
          priceEl.innerHTML = '<span class="gjones-modal__price-sale">' + formatMoney(priceVariant.price) + '</span>'
            + '<span class="gjones-modal__price-compare">' + formatMoney(priceVariant.compareAtPrice) + '</span>';
        } else {
          priceEl.textContent = formatMoney(priceVariant.price);
        }
      }
    }

    // -- State --
    var colorIdx = productData.colorOptionIndex;
    var sizeIdx  = productData.sizeOptionIndex;
    var selectedColor = null;
    var selectedVariantId = null;
    var quantity = 1;

    if (colorIdx !== null) {
      var activeSwatch = card.querySelector('.gjones-card__swatch--active');
      selectedColor = activeSwatch
        ? activeSwatch.getAttribute('data-color')
        : productData.variants[0].options[colorIdx];
    }

    // -- Quantity buttons (static in HTML) --
    if (qtyValEl) qtyValEl.textContent = quantity;
    if (minusBtn) minusBtn.onclick = function() {
      if (quantity > 1) { quantity--; if (qtyValEl) qtyValEl.textContent = quantity; }
    };
    if (plusBtn) plusBtn.onclick = function() {
      quantity++; if (qtyValEl) qtyValEl.textContent = quantity;
    };

    // -- Color swatches → injected into bodyEl --
    function renderColors() {
      if (!bodyEl) return;
      if (colorIdx === null) { bodyEl.innerHTML = ''; return; }
      // Suppress stagger re-animation when re-rendering after modal is open
      if (modal.classList.contains('is-open')) {
        bodyEl.style.animation = 'none';
      }
      var seenColors = [], colorVariants = [];
      productData.variants.forEach(function(v) {
        var c = v.options[colorIdx];
        if (seenColors.indexOf(c) === -1) { seenColors.push(c); colorVariants.push(v); }
      });
      var html = '<div class="gjones-modal__size-wrapper">';
      html += '<p class="gjones-modal__size-label">Colour: <span>' + (selectedColor || '') + '</span></p>';
      html += '<div class="gjones-modal__colors">';
      colorVariants.forEach(function(v) {
        var c = v.options[colorIdx];
        html += '<button class="gjones-modal__color-btn' + (c === selectedColor ? ' is-active' : '') + '" data-modal-color="' + c + '">';
        html += v.image ? '<img src="' + v.image + '" alt="' + c + '">' : '<span class="gjones-modal__color-dot"></span>';
        html += '</button>';
      });
      html += '</div></div>';
      bodyEl.innerHTML = html;

      bodyEl.querySelectorAll('[data-modal-color]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectedColor = btn.getAttribute('data-modal-color');
          var cv = productData.variants.filter(function(v) {
            return v.options[colorIdx] === selectedColor;
          })[0];
          if (cv && cv.image) {
            var i = images.indexOf(cv.image);
            showImage(i !== -1 ? i : 0);
          }
          renderColors();
          renderSizes();
        });
      });
    }

    // -- Sizes → injected into sizeOpts --
    function renderSizes() {
      if (!sizeOpts) return;
      if (sizeIdx === null) { if (sizesWrap) sizesWrap.hidden = true; return; }
      if (sizesWrap) sizesWrap.hidden = false;

      var variants = productData.variants;
      if (colorIdx !== null && selectedColor) {
        variants = variants.filter(function(v) { return v.options[colorIdx] === selectedColor; });
      }
      selectedVariantId = null;
      if (sizeValEl) sizeValEl.textContent = '';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Select a size'; }

      var seenSizes = [], html = '';
      variants.forEach(function(v) {
        var size = v.options[sizeIdx];
        if (seenSizes.indexOf(size) !== -1) return;
        seenSizes.push(size);
        var unavail = !v.available;
        html += '<button class="gjones-modal__size-btn' + (unavail ? ' is-unavailable' : '')
          + '" data-modal-size data-variant-id="' + v.id + '"' + (unavail ? ' disabled' : '') + '>'
          + size + '</button>';
      });
      sizeOpts.innerHTML = html;

      sizeOpts.querySelectorAll('[data-modal-size]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled) return;
          sizeOpts.querySelectorAll('[data-modal-size]').forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selectedVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (sizeValEl) sizeValEl.textContent = btn.textContent;
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Add to Cart';
            atcBtn.setAttribute('data-variant-id', selectedVariantId);
          }
        });
      });
    }

    // -- ATC (no sizes case: set variant directly) --
    if (sizeIdx === null) {
      var target = productData.variants.filter(function(v) {
        if (colorIdx !== null && selectedColor) return v.options[colorIdx] === selectedColor;
        return true;
      })[0];
      if (target && atcBtn) {
        selectedVariantId = target.id;
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
        atcBtn.setAttribute('data-variant-id', target.id);
      }
      if (sizesWrap) sizesWrap.hidden = true;
    }

    if (atcBtn) {
      atcBtn.onclick = function() {
        if (atcBtn.disabled) return;
        var vid = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        atcBtn.innerHTML = '<span class="gjones-spinner"></span>';
        atcBtn.disabled = true;
        addToCart(vid, quantity).then(function() {
          atcBtn.innerHTML = SUCCESS_ICON;
          modal._closeTimeout = setTimeout(function() { closeModal(modal); }, 900);
        }).catch(function(err) {
          atcBtn.textContent = err.message || 'Add to Cart';
          atcBtn.disabled = false;
          setTimeout(function() {
            if (atcBtn.textContent !== 'Add to Cart') atcBtn.textContent = 'Add to Cart';
          }, 3000);
        });
      };
    }

    // Cancel any pending auto-close
    if (modal._closeTimeout) { clearTimeout(modal._closeTimeout); modal._closeTimeout = null; }

    renderColors();
    renderSizes();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('gjones-modal-open');
  }

  function closeModal(modal) {
    modal.classList.add('is-closing');
    document.body.classList.add('gjones-modal-closing');
    var dialog = modal.querySelector('.gjones-modal__dialog');
    function onEnd() {
      dialog.removeEventListener('animationend', onEnd);
      modal.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('gjones-modal-open', 'gjones-modal-closing');
      document.body.style.overflow = '';
    }
    dialog.addEventListener('animationend', onEnd);
  }

  function bindSizeButtons(container) {
    container.querySelectorAll('.gjones-card__size-btn').forEach(function(btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;
        var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        var orig = btn.textContent;
        btn.innerHTML = '<span class="gjones-spinner"></span>';
        addToCart(vid).then(function() {
          btn.textContent = '\u2713';
          setTimeout(function() { btn.textContent = orig; }, 1500);
        }).catch(function() { btn.textContent = orig; });
      });
    });
  }

  /* ========================================
     Quick Add — Mobile Bottom Sheet
     ======================================== */
  function initQuickAddMobile(section) {
    var sheet = section.querySelector('[data-quick-add-sheet]');
    if (!sheet) return;

    // Event delegation — works for both static and AJAX-loaded cards
    section.addEventListener('click', function(e) {
      // Mobile direct add (no-size products)
      var directBtn = e.target.closest('.gjones-card__quick-add-mobile[data-quick-add-direct]');
      if (directBtn) {
        e.preventDefault();
        var vid = parseInt(directBtn.getAttribute('data-variant-id'), 10);
        if (!vid) return;
        addToCart(vid).then(function() {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        }).catch(function() {});
        return;
      }

      // Sheet open trigger
      var mobileBtn = e.target.closest('[data-quick-add-mobile]');
      if (mobileBtn && !mobileBtn.hasAttribute('data-quick-add-direct')) {
        e.preventDefault();
        var card = mobileBtn.closest('.gjones-card');
        if (!card) return;
        var dataEl = card.querySelector('[data-product-data]');
        if (!dataEl) return;
        var productData;
        try { productData = JSON.parse(dataEl.textContent); }
        catch (err) { return; }
        openBottomSheet(sheet, productData, card);
      }
    });

    // Sheet close (static HTML — bind once)
    sheet.querySelectorAll('[data-quick-add-sheet-close]').forEach(function(el) {
      el.addEventListener('click', function() { closeBottomSheet(sheet); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-active')) {
        closeBottomSheet(sheet);
      }
    });
  }

  function openBottomSheet(sheet, productData, card) {
    var body = sheet.querySelector('[data-quick-add-sheet-body]');
    if (!body) return;

    var colorIdx = productData.colorOptionIndex;
    var sizeIdx  = productData.sizeOptionIndex;

    // State
    var selectedColor     = null;
    var selectedVariantId = null;
    var quantity          = 1;

    if (colorIdx !== null) {
      var activeSwatch = card.querySelector('.gjones-card__swatch--active');
      selectedColor = activeSwatch
        ? activeSwatch.getAttribute('data-color')
        : productData.variants[0].options[colorIdx];
    }

    // Pull product info from card DOM
    var cardTitleEl = card.querySelector('.gjones-card__title');
    var productTitle = cardTitleEl ? cardTitleEl.textContent.trim() : '';
    var cardImg = card.querySelector('.gjones-card__img--primary');
    var thumbSrc = cardImg ? cardImg.src : '';

    // Price from first available variant
    var priceVariant = productData.variants.filter(function(v) { return v.available; })[0] || productData.variants[0];
    var priceHtml = '';
    if (priceVariant) {
      if (priceVariant.compareAtPrice && priceVariant.compareAtPrice > priceVariant.price) {
        priceHtml = '<span class="gjones-quick-add-sheet__price-sale">' + formatMoney(priceVariant.price) + '</span>'
          + '<span class="gjones-quick-add-sheet__price-compare">' + formatMoney(priceVariant.compareAtPrice) + '</span>';
      } else {
        priceHtml = formatMoney(priceVariant.price);
      }
    }

    function renderSheet() {
      var isColorChange = sheet.classList.contains('is-active');
      var html = '';

      // ---- Hero image ----
      var displayThumb = thumbSrc;
      if (colorIdx !== null && selectedColor) {
        var colorImgVariant = productData.variants.filter(function(v) {
          return v.options[colorIdx] === selectedColor && v.image;
        })[0];
        if (colorImgVariant) displayThumb = colorImgVariant.image;
      }
      var isOnSale = priceVariant && priceVariant.compareAtPrice && priceVariant.compareAtPrice > priceVariant.price;
      var imgOpacity = isColorChange ? ' style="opacity:0"' : '';

      html += '<div class="gjones-quick-add-sheet__product-hero">';
      if (displayThumb) html += '<img class="gjones-quick-add-sheet__hero-img"' + imgOpacity + ' src="' + displayThumb + '" alt="' + productTitle + '">';
      if (isOnSale) html += '<span class="gjones-quick-add-sheet__sale-badge">Sale</span>';
      html += '<div class="gjones-quick-add-sheet__hero-info">';
      html += '<p class="gjones-quick-add-sheet__product-name">' + productTitle + '</p>';
      html += '<p class="gjones-quick-add-sheet__product-price">' + priceHtml + '</p>';
      html += '</div>';
      html += '</div>';

      // ---- Color section ----
      if (colorIdx !== null) {
        var seenColors = [];
        var colorVariants = [];
        productData.variants.forEach(function(v) {
          var c = v.options[colorIdx];
          if (seenColors.indexOf(c) === -1) { seenColors.push(c); colorVariants.push(v); }
        });

        html += '<div class="gjones-quick-add-sheet__section">';
        html += '<p class="gjones-quick-add-sheet__label">Colour: <strong>' + selectedColor + '</strong></p>';
        html += '<div class="gjones-quick-add-sheet__colors">';
        colorVariants.forEach(function(v) {
          var c = v.options[colorIdx];
          html += '<button class="gjones-quick-add-sheet__color-btn' + (c === selectedColor ? ' is-active' : '') + '" data-sheet-color="' + c + '">';
          if (v.image) {
            html += '<img src="' + v.image + '" alt="' + c + '">';
          } else {
            html += '<span class="gjones-quick-add-sheet__color-dot"></span>';
          }
          html += '</button>';
        });
        html += '</div></div>';
      }

      // ---- Size section ----
      if (sizeIdx !== null) {
        var variants = productData.variants;
        if (colorIdx !== null && selectedColor) {
          variants = variants.filter(function(v) { return v.options[colorIdx] === selectedColor; });
        }

        selectedVariantId = null;

        var seenSizes = [];
        html += '<div class="gjones-quick-add-sheet__section">';
        html += '<p class="gjones-quick-add-sheet__label">Size</p>';
        html += '<div class="gjones-quick-add-sheet__sizes">';
        variants.forEach(function(v) {
          var size = v.options[sizeIdx];
          if (seenSizes.indexOf(size) !== -1) return;
          seenSizes.push(size);
          var soldOut = !v.available;
          html += '<button class="gjones-quick-add-sheet__size-btn'
            + (soldOut ? ' gjones-quick-add-sheet__size-btn--sold-out' : '')
            + '" data-sheet-size data-variant-id="' + v.id + '"'
            + (soldOut ? ' disabled' : '') + '>'
            + size + '</button>';
        });
        html += '</div></div>';
      }

      // ---- Footer: qty + ATC ----
      html += '<div class="gjones-quick-add-sheet__footer">';
      html += '<div class="gjones-quick-add-sheet__cart-row">';
      html += '<div class="gjones-quick-add-sheet__qty">';
      html += '<button class="gjones-quick-add-sheet__qty-btn" data-sheet-qty-minus>&minus;</button>';
      html += '<span class="gjones-quick-add-sheet__qty-val" data-sheet-qty-val>' + quantity + '</span>';
      html += '<button class="gjones-quick-add-sheet__qty-btn" data-sheet-qty-plus>+</button>';
      html += '</div>';

      if (sizeIdx !== null) {
        html += '<button class="gjones-quick-add-sheet__atc-btn" data-sheet-atc disabled>Select a size</button>';
      } else {
        var targetVariant = productData.variants.filter(function(v) {
          if (colorIdx !== null && selectedColor) return v.options[colorIdx] === selectedColor;
          return true;
        })[0];
        if (targetVariant) {
          selectedVariantId = targetVariant.id;
          html += '<button class="gjones-quick-add-sheet__atc-btn" data-sheet-atc data-variant-id="' + targetVariant.id + '">ADD TO BAG</button>';
        }
      }

      html += '</div>';
      html += '<a href="' + (productData.url || '#') + '" class="gjones-quick-add-sheet__view-link">View Full Details</a>';
      html += '</div>';

      body.innerHTML = html;

      if (isColorChange) {
        // Fade in the new hero image (was set to opacity:0 in markup)
        var heroImg = body.querySelector('.gjones-quick-add-sheet__hero-img');
        if (heroImg) {
          requestAnimationFrame(function() {
            requestAnimationFrame(function() { heroImg.style.opacity = '1'; });
          });
        }
        // Prevent stagger animation from replaying on colour change
        sheet.classList.remove('gjones-sheet-animating');
      }

      bindSheetEvents();
    }

    function bindSheetEvents() {
      var atcBtn = body.querySelector('[data-sheet-atc]');
      var qtyVal = body.querySelector('[data-sheet-qty-val]');

      // Color selection → re-render
      body.querySelectorAll('[data-sheet-color]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectedColor = btn.getAttribute('data-sheet-color');
          renderSheet();
        });
      });

      // Size selection → highlight + enable ATC
      body.querySelectorAll('[data-sheet-size]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (btn.disabled) return;
          body.querySelectorAll('[data-sheet-size]').forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selectedVariantId = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.textContent = 'ADD TO BAG';
            atcBtn.setAttribute('data-variant-id', selectedVariantId);
          }
        });
      });

      // Quantity buttons
      var minusBtn = body.querySelector('[data-sheet-qty-minus]');
      var plusBtn  = body.querySelector('[data-sheet-qty-plus]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          if (quantity > 1) { quantity--; if (qtyVal) qtyVal.textContent = quantity; }
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          quantity++;
          if (qtyVal) qtyVal.textContent = quantity;
        });
      }

      // ATC button
      if (atcBtn) {
        atcBtn.addEventListener('click', function() {
          if (atcBtn.disabled) return;
          var vid = parseInt(atcBtn.getAttribute('data-variant-id'), 10);
          if (!vid) return;
          atcBtn.innerHTML = '<span class="gjones-spinner"></span>';
          atcBtn.disabled = true;
          addToCart(vid, quantity).then(function() {
            atcBtn.innerHTML = SUCCESS_ICON;
            setTimeout(function() { closeBottomSheet(sheet); }, 900);
          }).catch(function(err) {
            atcBtn.textContent = err.message || 'ADD TO BAG';
            atcBtn.disabled = false;
            setTimeout(function() {
              if (atcBtn.textContent !== 'ADD TO BAG') atcBtn.textContent = 'ADD TO BAG';
            }, 3000);
          });
        });
      }
    }

    renderSheet();
    sheet.classList.add('is-active', 'gjones-sheet-animating');
    document.body.classList.add('drawer-open');
    setTimeout(function() { sheet.classList.remove('gjones-sheet-animating'); }, 700);
  }

  function closeBottomSheet(sheet) {
    sheet.classList.remove('is-active', 'gjones-sheet-animating');
    document.body.classList.remove('drawer-open');
  }

  /* ========================================
     Wishlist Buttons
     ======================================== */
  function markWishlistActive(container) {
    container.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (isInWishlist(handle)) btn.classList.add('is-active');
    });
  }

  function initWishlistButtons(container) {
    markWishlistActive(container);

    // Event delegation — works for both static and AJAX-loaded cards
    container.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      // Layout 3 grids handle their own wishlist via gjones-product-grid-3.js
      if (btn.closest('.gjones-product-grid--layout-3')) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle');
      var added = toggleWishlist(handle);
      btn.classList.toggle('is-active', added);
    });
  }

  /* ========================================
     Color Swatches
     ======================================== */
  function initSwatches(section) {
    // Event delegation — works for both static and AJAX-loaded cards
    section.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-swatch]');
      if (!swatch) return;
      // Layout 3 grids handle swatches + size bar rebuild via gjones-product-grid-3.js
      if (swatch.closest('.gjones-product-grid--layout-3')) return;
      e.preventDefault();

      var container = swatch.closest('[data-swatches]');
      if (!container) return;
      var card = container.closest('.gjones-card');
      if (!card) return;

      var color = swatch.getAttribute('data-color');
      var imageUrl = swatch.getAttribute('data-image');

      container.querySelectorAll('[data-swatch]').forEach(function(s) {
        s.classList.remove('gjones-card__swatch--active');
      });
      swatch.classList.add('gjones-card__swatch--active');

      if (imageUrl) {
        var primaryImg = card.querySelector('.gjones-card__img--primary');
        if (primaryImg) {
          primaryImg.src = imageUrl;
          primaryImg.srcset = '';
        }
      }

      var dataEl = card.querySelector('[data-product-data]');
      if (dataEl) {
        try {
          var productData = JSON.parse(dataEl.textContent);
          updateQuickAddSizes(card, productData, color);
        } catch (err) {}
      }
    });
  }

  function updateQuickAddSizes(card, productData, selectedColor) {
    var sizesContainer = card.querySelector('[data-quick-add-sizes]');
    if (!sizesContainer || productData.sizeOptionIndex === null) return;

    var sizeIdx = productData.sizeOptionIndex;
    var colorIdx = productData.colorOptionIndex;
    var variants = productData.variants;

    if (colorIdx !== null && selectedColor) {
      variants = variants.filter(function(v) {
        return v.options[colorIdx] === selectedColor;
      });
    }

    var html = '';
    variants.forEach(function(v) {
      var size = v.options[sizeIdx];
      var soldOut = !v.available;
      html += '<button class="gjones-card__size-btn'
        + (soldOut ? ' gjones-card__size-btn--sold-out' : '')
        + '" data-variant-id="' + v.id + '"'
        + (soldOut ? ' disabled' : '') + '>'
        + size + '</button>';
    });

    sizesContainer.innerHTML = html;
    bindSizeButtons(sizesContainer);
  }

  /* ========================================
     Boot
     ======================================== */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function() {
    document.querySelectorAll('.gjones-collection-tabs').forEach(initSection);

    // For sections that load cards via AJAX (product-recommendations):
    // init slider + mark wishlist active states once content arrives.
    document.querySelectorAll('.gjones-collection-tabs product-recommendations').forEach(function(el) {
      var section = el.closest('.gjones-collection-tabs');
      if (!section) return;
      var obs = new MutationObserver(function(mutations, observer) {
        var hasNodes = mutations.some(function(m) {
          return Array.prototype.some.call(m.addedNodes, function(n) { return n.nodeType === 1; });
        });
        if (!hasNodes) return;
        observer.disconnect();
        initSliders(section);
        markWishlistActive(el);
      });
      obs.observe(el, { childList: true });
    });
  });
})();
